"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants = require("../constants/constants");
var Persistence = /** @class */ (function () {
    function Persistence() {
    }
    Persistence.isLocalStorageNameSupported = function () {
        var testKey = 'test', storage = window.localStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        }
        catch (error) {
            return false;
        }
    };
    Persistence.getItem = function (key) {
        if (Persistence.isLocalStorageNameSupported()) {
            return localStorage.getItem(key);
        }
        return Persistence.tempStorage[key];
    };
    Persistence.setItem = function (key, value) {
        if (Persistence.isLocalStorageNameSupported()) {
            localStorage.setItem(key, value);
        }
        else {
            var storedValue = value;
            if (value == true) {
                storedValue = "true";
            }
            else if (value == false) {
                storedValue = "false";
            }
            Persistence.tempStorage[key] = storedValue;
        }
    };
    Persistence.usesSIUnits = function () {
        var usesSI = Persistence.getItem(constants.kUsesSIUnits);
        if (usesSI == null) {
            return false;
        }
        return usesSI == "true";
    };
    Persistence.setUsesSIUnits = function (usesSIUnits) {
        Persistence.setItem(constants.kUsesSIUnits, usesSIUnits);
    };
    Persistence.hasAcceptedEULA = function () {
        var accepted = Persistence.getItem(constants.kHasAcceptedEULA);
        if (accepted == null) {
            return false;
        }
        return accepted == "true";
    };
    Persistence.setHasAcceptedEULA = function (accepted) {
        Persistence.setItem(constants.kHasAcceptedEULA, accepted);
        console.log(Persistence.tempStorage);
    };
    Persistence.tempStorage = {};
    return Persistence;
}());
exports.default = Persistence;
//# sourceMappingURL=Persistence.js.map


/** WEBPACK FOOTER **
 ** ./src/Persistence/Persistence.js
 **/